import './App.css';
import { Route, BrowserRouter as Router, Routes, Navigate } from "react-router-dom";
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import { Employee } from './pages/Employee';
import { AddEmployee } from './pages/AddEmployee';
import { CollegeManager } from './pages/CollegeManager';
import AddCollege from './pages/AddCollege';
import { StudentManager } from './pages/StudentManager';
import EditProfile from './pages/EditProfile';
import AddStudent from './pages/AddStudent';
import NlNcStudentManager from './pages/NlNcStudentManager';
import CourseManager from './pages/CourseManager';
import { AddCourse } from './pages/AddCourse';
import CategoryManager from './pages/CategoryManager';
import AdmissionManager from './pages/AdmissionManager';
import AddAdmissionForm from './pages/AddAdmissionForm';
import EditAdmissionForm from './pages/EditAdmissionForm';
import AdmissionView from './pages/AdmissionView';
import { useEffect, useState } from 'react';

function App() {
  const [isLogin, setIsLogin] = useState(!!localStorage.getItem("token"));
  const [userRole, setUserRole] = useState(JSON.parse(localStorage.getItem("userData")));

  useEffect(() => {
    const checkLogin = () => {
      if (localStorage.getItem("token")) {
        setIsLogin(true);
      } else {
        setIsLogin(false);
      }
    };
    
    window.addEventListener("storage", checkLogin); // Listen for token changes

    return () => {
      window.removeEventListener("storage", checkLogin);
    };
  }, []);

  useEffect(()=>{
    if(localStorage.getItem("userData")){
      setUserRole(JSON.parse(localStorage.getItem("userData")))
    }
  },[])

  return (
    <Router>
      <Routes>
        {!isLogin ? (
          <>
            <Route path="/login" element={<Login setIsLogin={setIsLogin} />} />
            <Route path="/admission/:slug" element={<AdmissionView />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </>
        ) : (
          <>
          <Route path="/login" element={<Login setIsLogin={setIsLogin} />} />
            <Route path="/" element={<Dashboard />} />
            <Route path="/edit-profile" element={<EditProfile />} />
            <Route path="/admission/:slug" element={<AdmissionView />} />
            {
              userRole?.role === "admin" && <>
                <Route path="/employee-manager" element={<Employee />} />
            <Route path="/add-employee" element={<AddEmployee />} />
            <Route path="/edit-employee" element={<AddEmployee />} />
            <Route path="/view-employee" element={<AddEmployee />} />
              </>
            }
          
           {(userRole?.role === "admin" || userRole?.managers?.["College Manager"]) && <> <Route path="/college-manager" element={<CollegeManager />} />
            <Route path="/view-college" element={<AddCollege />} />
            {(userRole?.role === "admin" || userRole?.managers?.["College Manager"]?.add) && <><Route path="/edit-college" element={<AddCollege />} />
            <Route path="/add-college" element={<AddCollege />} /></> }
            </>
            }
             {(userRole?.role === "admin" || userRole?.managers?.["Student Manager"]) && <><Route path="/student-manager" element={<StudentManager />} />
            <Route path="/nl-nc-student-manager" element={<NlNcStudentManager />} />
            <Route path="/view-student" element={<AddStudent />} />
            {(userRole?.role === "admin" || userRole?.managers?.["Student Manager"]?.add) && <><Route path="/add-student" element={<AddStudent />} />
            <Route path="/edit-student" element={<AddStudent />} /></>} </>}

            {(userRole?.role === "admin" || userRole?.managers?.["Course Manager"]) && <><Route path="/course-manager" element={<CourseManager />} />
            <Route path="/view-course" element={<AddCourse />} />
            {(userRole?.role === "admin" || userRole?.managers?.["Course Manager"]?.add) && <><Route path="/add-course" element={<AddCourse />} />
            <Route path="/edit-course" element={<AddCourse />} /> </>} </>}
            
            {(userRole?.role === "admin" || userRole?.managers?.["Category Manager"]) && <><Route path="/category-manager" element={<CategoryManager />} /> </>}
            
            {(userRole?.role === "admin" || userRole?.managers?.["Admission Manager"]) && <>
              <Route path="/admission-manager" element={<AdmissionManager />} />
              <Route path="/add-admission" element={<AddAdmissionForm />} />
              <Route path="/edit-admission/:admissionId" element={<EditAdmissionForm />} />
              <Route path="/view-admission/:admissionId" element={<EditAdmissionForm />} />
            </>}
            
            <Route path="*" element={<Navigate to="/" />} />
          </>
        )}
      </Routes>
    </Router>
  );
}

export default App;
